import store from '@/store'

/**
 * ページ遷移時のスクロール処理
 */
export const scrollBehavior = (to, from, savedPosition) => {
  console.log('[scrollBehavior]', to.name, from.name, savedPosition)
  store.commit('setCurrentSavedPosition', savedPosition ? savedPosition : { x: 0, y: 0 })
  if ((from.meta.basePage && to.name === 'mypage') || !to.meta.basePage) {
    return { x: 0, y: 0 }
  }

  // pull refresh 実装ページは savedPosition がなければ事前に保存していたスクロール値を復元する
  const isRestoreSavedPositionFromStore = /(TopUser|MessageList|Timeline|Footprint|SearchResultUser)/.test(
    store.getters.fromStoreModuleName
  )
  if (isRestoreSavedPositionFromStore) {
    const moduleSavedPosition = store.getters[`${store.getters.fromStoreModuleName}/savedPosition`]
    // if (to.name === 'timeline') {
    //   return moduleSavedPosition
    // }

    if (savedPosition) {
      store.commit(`${store.getters.fromStoreModuleName}/setSavedPosition`, savedPosition)
    } else {
      return moduleSavedPosition
    }
  }
  return savedPosition
}
